




















































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

import { CoreTeamMeeting, CoreTeamMeetingInformation } from '../common/form-type.interface';
import { LooseObject, MonthYear } from '../common/common-type.interface';

import util from '../common/utility';

@Component({})
export default class extends Vue {
    public classes: LooseObject[] = [];

    @Prop() public coreTeamMeeting: CoreTeamMeeting | any;

    @Prop() private month: any;
    @Prop() private year: any;

    public addClass() {
        this.coreTeamMeeting.data.meetings.forEach( (meeting: CoreTeamMeetingInformation) => {
            const classes: LooseObject = {};

            for ( const key in meeting ) {
                if (key === 'id') {
                    continue;
                }

                classes[key] = { 'is-valid': false, 'is-invalid': true };
            }

            this.classes.push(classes);
        });
    }

    public created() {
        this.addClass();

        this.nextFormValidation(false);
    }

    public saveData(data: string) {
        util.eventBus.$emit('data', { type: 'coreTeamMeeting', data });
    }

    public addNewMeetingDetails() {
        this.coreTeamMeeting.data.meetings.push({
            id: Date.now(),
            date: '',
            pointsDiscussed: ''
        });

        this.classes.push({
            date: {'is-valid': false, 'is-invalid': true},
            pointsDiscussed: {'is-valid': false, 'is-invalid': true}
        });

        this.saveData('new');
    }

    public removeMeetingDetails(index: number) {
        this.coreTeamMeeting.data.meetings.splice(index, 1);

        this.classes.splice(index, 1);

        this.saveData('removed: ' + index);
    }

    public validateInput(event: Event, index: number, name: string) {
        const val = (event.target as HTMLFormElement).value.trim();

        let error = false;

        switch ( name ) {
            case 'date':
                error = util.isInvalidMonthYear(this.month, this.year, val);
                break;
            case 'pointsDiscussed':
                error = val === '';
                break;
        }

        this.classes[index][name]['is-invalid'] = error;
        this.classes[index][name]['is-valid'] = !error;
    }

    public nextFormValidation(submitForm: boolean) {
        if ( this.coreTeamMeeting.data.hadMeeting === 'yes' ) {
            // 1a - had meeting validation
            let yesValid = true;

            this.coreTeamMeeting.data.meetings.forEach( (v: any, i: number) => {
                for (const key in this.classes[i]) {
                    if ( this.classes[i].hasOwnProperty(key) ) {
                        let error = false;

                        if (key === 'date') {
                            error = util.isInvalidMonthYear(this.month, this.year, v.date);
                        } else {
                            error = v[key].trim() === '';
                        }

                        this.classes[i][key]['is-invalid'] = error;
                        this.classes[i][key]['is-valid'] = !error;

                        if ( error ) {
                            yesValid = false;
                        }
                    }
                }
            });

            this.coreTeamMeeting.isValid = yesValid;
        } else {
            // 1b - no meeting validation
            this.coreTeamMeeting.isValid = this.coreTeamMeeting.data.noMeetingRemarks.trim() !== '';
        }

        util.eventBus.$emit('data', { coreTeamMeetingData: 'data i/o' });

        // 2 - Submit form if valid
        if (submitForm && this.coreTeamMeeting.isValid) {
            this.$router.push('discipleship-meetings');
        }
    }

    public meetingChange() {
        util.eventBus.$emit('data', { coreTeamMeetingStatus: this.coreTeamMeeting.data.hadMeeting });
    }

    get MonthYear(): MonthYear {
        return {
            month: this.month,
            year: this.year
        };
    }

    get minDate() {
        return this.year + '-' + util.addZero(this.month) + '-01';
    }

    get maxDate() {
        const maxDate = new Date(this.year, this.month, 0);

        return this.year + '-' + util.addZero((maxDate.getMonth() + 1)) + '-' + maxDate.getDate();
    }

    get isInvalid() {
        let error = false;

        if ( this.coreTeamMeeting.data.hadMeeting === 'yes' ) {
            this.classes.forEach((row: LooseObject, index: number) => {
                for ( const key in row ) {
                    if ( row.hasOwnProperty(key) ) {
                        if ( row[key]['is-invalid'] ) {
                            error = true;
                        }
                    }
                }
            });
        } else {
            error = this.coreTeamMeeting.data.noMeetingRemarks.trim() === '';
        }

        this.coreTeamMeeting.isValid = !error;

        return error;
    }

    @Watch('MonthYear')
    private watchMonthYear(monthYear: MonthYear, oldValue: MonthYear) {
        if (oldValue && oldValue.month !== 0) {
            this.coreTeamMeeting.data.meetings.forEach((meeting: CoreTeamMeetingInformation, index: number) => {
                const error = util.isInvalidMonthYear(this.month, this.year, meeting.date);

                this.classes[index].date['is-invalid'] = error;
                this.classes[index].date['is-valid'] = !error;

                if (error) {
                    this.coreTeamMeeting.isValid = false;
                }
            });
        }
    }
}
